import {css} from 'styled-components';

import {boxShadow} from '../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Types.
 */

/** Used for cell alignment. */
export enum TableHeadersEnum {
  TEXT = 'text',
  NUMERICAL = 'numerical',
}

/*
 * Styles.
 */

export const stickyColumn = css`
  position: sticky;
  left: 0;
  background-color: inherit;
  ${(p) => boxShadow(p.theme, `0px 8px 9px ${p.theme.alphas.black20}`)};
`;
